export const blockIconsBusinessandpaymentsSellNew = (
	<span className='material-symbols-outlined'>sell</span>
);
